import React from "react"

export default () => {
    return <span className="dot-typing"></span>
}